import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
 
export default /*#__PURE__*/_defineComponent({
  __name: 'NCascader',
  props: {
    value: null,
    options: null,
    fieldNames: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as {
    value?: any;
    options?: any; 
    fieldNames?: any;
 };

/**
 * 该组件用于配和 v-decorator,其自动生成的value为选择的最后一项
 */

 
 function change(val: any[]){
    emit('change',val[val.length-1])
 }
 function dfsTree(tree: any[],value,res: any[] = []){
    const key = props.fieldNames.value
    const children =  props.fieldNames.children
    let data: any[] = []
    for(let i=0 ;i<=tree?.length;i++){
        const node = tree[i]
         data = [...res,node?.[key]];
         if(data[data.length-1]==value){
            break
         }
        if(node?.[children]){
           data =  dfsTree(node?.[children],value,data)
           if(data[data.length-1]==value){
            break
         }
        }
    }
    return data

 }
 watch(()=>props.value,()=>{
    if(props.value){
        const res = dfsTree(props.options,props.value)
        data.value = res
    }else{
        data.value = []
    }
 })
 const data= ref<any>([])

return { __sfc: true,props, emit, change, dfsTree, data }
}

})